/*
 * tq-catalog — client-side filtering / sorting over the store's green coffees.
 * Progressive enhancement on top of the server-rendered catalog emitted by
 * snippets/tq-catalog.liquid (homepage + collection pages). Product data is
 * rendered as JSON (script[data-tq-catalog]); UI strings come from
 * window.tqStrings; add-to-cart uses the real Shopify AJAX Cart API.
 */
(function () {
  const root = document.querySelector('.tq-catalog');
  if (!root) return;
  const $ = (s) => root.querySelector(s);
  const _dollar_global = (s) => document.querySelector(s);   // elements outside .tq-catalog (e.g. #tq-cc in global header)

  const S = window.tqStrings || {};
  const SYM = S.moneySymbol || '$';

  // ---- product data -------------------------------------------------------
  let DATA = [];
  try {
    DATA = JSON.parse(document.querySelector('[data-tq-catalog]').textContent) || [];
  } catch (e) {
    DATA = [];
  }

  // Origin country: prefer the Shopify category metafield "Pays" (shopify.country),
  // emitted as `coTax` = [{label, taxonomy_reference}, …]. Its taxonomy-value label
  // ("Nicaragua", "Pérou", …) is clean and localized, so it maps to a flag reliably
  // where the legacy free-text `co` (origine) often didn't. Keep the taxonomy_reference
  // GID around (coTaxId) as a language-independent key for future use. Fall back to the
  // origine value already in `co` for products with no category country set.
  DATA.forEach((c) => {
    const t = Array.isArray(c.coTax) ? c.coTax[0] : null;
    // Keep the legacy free-text spelling for the search haystack: `co` is about
    // to be replaced by the taxonomy label, and the two often differ.
    c.coRaw = c.co;
    if (t && t.label) c.co = t.label;
    if (t && t.taxonomy_reference) c.coTaxId = t.taxonomy_reference;
  });

  // Coffee-producing origins of the world ("the bean belt"), hardcoded.
  // Each entry: [continent, flag emoji, [name variants in EN / FR / ES]].
  // The `origine` metafield may be filled in any of the store's working
  // languages (and with or without accents), so every spelling we expect maps
  // to the same flag + continent grouping. Add new spellings to the same row.
  const ORIGINS = [
    // ---- Africa ----
    ['Africa', '🇪🇹', ['Ethiopia', 'Éthiopie', 'Ethiopie', 'Etiopía', 'Etiopia']],
    ['Africa', '🇰🇪', ['Kenya']],
    ['Africa', '🇷🇼', ['Rwanda']],
    ['Africa', '🇧🇮', ['Burundi']],
    ['Africa', '🇹🇿', ['Tanzania', 'Tanzanie', 'Tanzanía']],
    ['Africa', '🇺🇬', ['Uganda', 'Ouganda']],
    ['Africa', '🇨🇩', ['DR Congo', 'DRC', 'RDC', 'RD Congo', 'Congo', 'Democratic Republic of the Congo', 'République démocratique du Congo', 'Republique democratique du Congo', 'República Democrática del Congo']],
    ['Africa', '🇨🇬', ['Republic of the Congo', 'Congo-Brazzaville', 'République du Congo', 'República del Congo']],
    ['Africa', '🇨🇲', ['Cameroon', 'Cameroun', 'Camerún', 'Camerun']],
    ['Africa', '🇨🇮', ["Ivory Coast", "Côte d'Ivoire", "Cote d'Ivoire", 'Costa de Marfil']],
    ['Africa', '🇿🇲', ['Zambia', 'Zambie', 'Zambia']],
    ['Africa', '🇲🇼', ['Malawi', 'Malaui']],
    ['Africa', '🇿🇼', ['Zimbabwe', 'Zimbabue']],
    ['Africa', '🇲🇬', ['Madagascar']],
    ['Africa', '🇦🇴', ['Angola']],
    ['Africa', '🇹🇬', ['Togo']],
    ['Africa', '🇬🇳', ['Guinea', 'Guinée', 'Guinee']],
    ['Africa', '🇸🇱', ['Sierra Leone', 'Sierra Léone', 'Sierra Leona']],
    ['Africa', '🇳🇬', ['Nigeria', 'Nigéria']],
    ['Africa', '🇬🇭', ['Ghana']],
    ['Africa', '🇸🇸', ['South Sudan', 'Soudan du Sud', 'Sudán del Sur', 'Sudan del Sur']],
    ['Africa', '🇸🇭', ['Saint Helena', 'Sainte-Hélène', 'Sainte-Helene', 'Santa Elena']],
    // ---- South America ----
    ['South America', '🇨🇴', ['Colombia', 'Colombie']],
    ['South America', '🇧🇷', ['Brazil', 'Brésil', 'Bresil', 'Brasil']],
    ['South America', '🇵🇪', ['Peru', 'Pérou', 'Perou', 'Perú']],
    ['South America', '🇪🇨', ['Ecuador', 'Équateur', 'Equateur']],
    ['South America', '🇧🇴', ['Bolivia', 'Bolivie']],
    ['South America', '🇻🇪', ['Venezuela', 'Vénézuela', 'Venezuela']],
    ['South America', '🇬🇾', ['Guyana', 'Guyana']],
    // ---- Central America & Caribbean ----
    ['Central America', '🇭🇳', ['Honduras']],
    ['Central America', '🇬🇹', ['Guatemala']],
    ['Central America', '🇨🇷', ['Costa Rica']],
    ['Central America', '🇳🇮', ['Nicaragua']],
    ['Central America', '🇸🇻', ['El Salvador', 'Salvador']],
    ['Central America', '🇵🇦', ['Panama', 'Panamá']],
    ['Central America', '🇨🇺', ['Cuba']],
    ['Central America', '🇩🇴', ['Dominican Republic', 'République dominicaine', 'Republique dominicaine', 'República Dominicana', 'Republica Dominicana']],
    ['Central America', '🇭🇹', ['Haiti', 'Haïti', 'Haití']],
    ['Central America', '🇯🇲', ['Jamaica', 'Jamaïque', 'Jamaique', 'Jamaica']],
    ['Central America', '🇵🇷', ['Puerto Rico', 'Porto Rico']],
    // ---- North America ----
    ['North America', '🇲🇽', ['Mexico', 'Mexique', 'México', 'Méjico', 'Mejico']],
    // ---- Asia ----
    ['Asia', '🇮🇩', ['Indonesia', 'Indonésie', 'Indonesie', 'Sumatra', 'Sumatera', 'Java', 'Sulawesi', 'Bali', 'Flores']],
    ['Asia', '🇮🇳', ['India', 'Inde']],
    ['Asia', '🇻🇳', ['Vietnam', 'Viêt Nam', 'Viet Nam', 'Việt Nam']],
    ['Asia', '🇾🇪', ['Yemen', 'Yémen', 'Yemen']],
    ['Asia', '🇨🇳', ['China', 'Chine']],
    ['Asia', '🇱🇦', ['Laos']],
    ['Asia', '🇹🇭', ['Thailand', 'Thaïlande', 'Thailande', 'Tailandia']],
    ['Asia', '🇵🇭', ['Philippines', 'Filipinas']],
    ['Asia', '🇲🇲', ['Myanmar', 'Burma', 'Birmanie', 'Birmania']],
    ['Asia', '🇹🇱', ['Timor-Leste', 'East Timor', 'Timor oriental', 'Timor Oriental']],
    ['Asia', '🇳🇵', ['Nepal', 'Népal']],
    ['Asia', '🇱🇰', ['Sri Lanka']],
    ['Asia', '🇲🇾', ['Malaysia', 'Malaisie', 'Malasia']],
    // ---- Oceania / Pacific ----
    ['Oceania', '🇵🇬', ['Papua New Guinea', 'PNG', 'Papouasie-Nouvelle-Guinée', 'Papouasie-Nouvelle-Guinee', 'Papúa Nueva Guinea', 'Papua Nueva Guinea']],
    ['Oceania', '🇺🇸', ['Hawaii', 'Hawaï', 'Hawai', 'Hawái']],
    ['Oceania', '🇦🇺', ['Australia', 'Australie']],
    ['Oceania', '🇳🇨', ['New Caledonia', 'Nouvelle-Calédonie', 'Nouvelle-Caledonie', 'Nueva Caledonia']],
    ['Oceania', '🇻🇺', ['Vanuatu']],
    ['Oceania', '🇫🇯', ['Fiji', 'Fidji', 'Fiyi']],
    ['Oceania', '🇼🇸', ['Samoa']],
  ];
  const CONT = ['South America', 'Africa', 'Central America', 'North America', 'Oceania', 'Asia'];
  const CONT_LABEL = S.continents || {};
  const COUNTRY_TO_CONTINENT = {};
  const COUNTRY_TO_FLAG = {};
  const deburr = (s) => String(s == null ? '' : s).normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase();
  // Origin lookup key: accent/case/punctuation-insensitive, because the
  // free-text `origine` metafield varies ("Costa-Rica", "costa rica", …).
  const keyOf = (co) => deburr(co).replace(/[^a-z]+/g, ' ').trim();
  ORIGINS.forEach(([cont, flag, names]) => names.forEach((n) => {
    COUNTRY_TO_CONTINENT[keyOf(n)] = cont;
    COUNTRY_TO_FLAG[keyOf(n)] = flag;
  }));
  const OTHER = S.other || 'Other';
  const continentOf = (co) => COUNTRY_TO_CONTINENT[keyOf(co)] || OTHER;
  const contLabel = (k) => CONT_LABEL[k] || k;
  const flagOf = (co) => COUNTRY_TO_FLAG[keyOf(co)] || '';

  // Search synonyms. The catalogue data is French-first, but shoppers type in
  // either language (the US market types English only), and certifications get
  // spelled several ways across products ("Bio", "Biologique", "FTO"). When any
  // member of a group is found in a product's haystack, the whole group is
  // appended to it — so "organic" finds a coffee whose certification says "Bio".
  // Terms are deburred + lowercase, and matched at a word start (prefix), so
  // "bio" also matches "biologique".
  const SYNONYMS = [
    ['bio', 'biologique', 'organic', 'organique', 'organico'],
    ['equitable', 'commerce equitable', 'fairtrade', 'fair trade', 'fto'],
    ['rfa', 'rainforest alliance'],
    ['decafeine', 'decafeinee', 'decaf', 'decaffeinated', 'sans cafeine', 'swiss water'],
    ['lave', 'washed', 'lavado'],
    ['naturel', 'nature', 'natural'],
    ['miel', 'honey'],
    ['anaerobie', 'anaerobique', 'anaerobic', 'maceration carbonique', 'carbonic maceration'],
    ['peaberry', 'caracoli', 'grain rond'],
    ['robusta', 'canephora'],
  ];
  // `s` is space-joined, so a term is present when it starts the string or
  // follows a space — a prefix match on a word, never mid-word.
  const hasTerm = (s, t) => s.lastIndexOf(t, 0) === 0 || s.indexOf(' ' + t) !== -1;
  const flat = (x) => (Array.isArray(x) ? x.join(' ') : x);

  // Accent/case-insensitive search haystack per product, precomputed once.
  // It must cover every field the card can display (see tq-catalog-card.liquid),
  // plus the product tags — otherwise a row shows a value the search can't find.
  DATA.forEach((c) => {
    const parts = [c.nm, c.co, c.coRaw, c.proc, c.prod, c.reg, c.coop, c.farm, c.grade];
    parts.push(flat(c.v), flat(c.notes), flat(c.cert), flat(c.tags));
    let s = deburr(parts.filter(Boolean).join(' '));
    SYNONYMS.forEach((group) => {
      if (group.some((t) => hasTerm(s, t))) s += ' ' + group.join(' ');
    });
    c._s = s;
  });

  // ---- state --------------------------------------------------------------
  const f = { countries: [], procs: [], pals: [], fmt: null, pMin: null, pMax: null, sale: false, isNew: false, avail: false, q: '' };
  const qInput = $('#tq-q');
  let sort = 'latest';

  const perLbOf = (s) => (s.w > 0 ? s.p / s.w : s.p);
  // Products with no weight basis (equipment) have no meaningful $/lb, so they
  // drop out as soon as the price filter is active rather than being compared
  // on their full price.
  const hasPerLb = (c) => c.sizes.some((s) => s.w > 0);
  // With a bag-format filter active, price/stock logic only looks at the
  // matching size — sorting, the price filter and the stock grouping all
  // follow the format the customer picked.
  const fmtSizes = (c) => (f.fmt == null ? c.sizes : c.sizes.filter((s) => s.w === f.fmt));
  // Cheapest $/lb across the product's (format-filtered) sizes — the same
  // per-lb figure printed on each size line, so the sorted order matches
  // what the customer sees.
  const minPerLb = (c) => Math.min.apply(null, fmtSizes(c).map(perLbOf));
  const perLbRange = (c) => {
    const v = fmtSizes(c).map(perLbOf);
    return [Math.min.apply(null, v), Math.max.apply(null, v)];
  };
  const inStock = (c) => fmtSizes(c).some((s) => s.a !== 'out');
  const fmt = (str, vars) => String(str || '').replace(/\{(\w+)\}/g, (m, k) => (k in vars ? vars[k] : m));

  function sorted() {
    const terms = deburr(f.q).split(/\s+/).filter(Boolean);
    let a = DATA.filter((c) => {
      if (terms.length && !terms.every((t) => c._s.includes(t))) return false;
      if (f.countries.length && !f.countries.includes(c.co)) return false;
      if (f.procs.length && !f.procs.includes(c.proc)) return false;
      if (f.pals.length && !f.pals.includes(c.pal)) return false;
      if (f.sale && !c.sale) return false;
      if (f.isNew && !c.isNew) return false;
      if (f.avail && !inStock(c)) return false;
      if (f.fmt != null && !c.sizes.some((s) => s.w === f.fmt)) return false;
      const priceFiltered = f.pMin != null || f.pMax != null;
      if (priceFiltered && !hasPerLb(c)) return false;
      const [lo, hi] = perLbRange(c);
      if (f.pMin != null && hi < f.pMin) return false;
      if (f.pMax != null && lo > f.pMax) return false;
      return true;
    });
    const cmp = {
      latest: (x, y) => String(y.date).localeCompare(String(x.date)),
      'price-asc': (x, y) => minPerLb(x) - minPerLb(y),
      'price-desc': (x, y) => minPerLb(y) - minPerLb(x),
      alpha: (x, y) => (x.co + x.nm).localeCompare(y.co + y.nm),
      origin: (x, y) => CONT.indexOf(continentOf(x.co)) - CONT.indexOf(continentOf(y.co)) || String(x.co).localeCompare(y.co),
    }[sort];
    a.sort(cmp);
    // Alphabetical stays a pure A→Z list: no sale pinning, no out-of-stock
    // sinking. Price sorts are a strict $/lb ladder: no sale pinning either,
    // and weightless gear (no meaningful $/lb, perLbOf falls back to its full
    // price) sinks below the coffees. Latest/origin keep the merchandising
    // grouping — on-sale first. In every non-alpha sort, fully out-of-stock
    // products sink to the bottom (most dominant, so applied last).
    const priceSort = sort === 'price-asc' || sort === 'price-desc';
    if (sort !== 'alpha') {
      if (!priceSort) a.sort((x, y) => (y.sale ? 1 : 0) - (x.sale ? 1 : 0));
      if (priceSort) a.sort((x, y) => (hasPerLb(x) ? 0 : 1) - (hasPerLb(y) ? 0 : 1));
      a.sort((x, y) => (inStock(x) ? 0 : 1) - (inStock(y) ? 0 : 1));
    }
    return a;
  }

  function render() {
    const a = sorted();
    $('#tq-n').textContent = a.length;

    // Live count on the mobile sheet's "View N coffees" button
    const applyBtn = $('#tq-mobApply');
    if (applyBtn) {
      const sr = S.showResults || {};
      applyBtn.textContent = a.length === 0 ? (sr.zero || '0')
        : a.length === 1 ? (sr.one || '1')
        : (sr.other || '[count]').replace('[count]', a.length);
      applyBtn.classList.toggle('is-zero', a.length === 0);
    }
    const list = $('#tq-list');
    const cards = list.querySelectorAll('.row');
    const cardById = {};
    cards.forEach(function (c) { cardById[c.dataset.id] = c; });
    const visible = new Set(a.map(function (x) { return String(x.id); }));

    // Show/hide
    cards.forEach(function (c) {
      c.style.display = visible.has(c.dataset.id) ? '' : 'none';
    });

    // With a bag-format filter active, only that size's line shows in each row
    list.querySelectorAll('.sb[data-w]').forEach(function (sb) {
      sb.classList.toggle('sb-fmt-hidden', f.fmt != null && +sb.dataset.w !== f.fmt);
    });

    // Zero state: active filters match no coffee
    const noMatch = $('#tq-noMatch');
    if (noMatch) noMatch.hidden = a.length > 0 || !cards.length;

    // Reorder: appendChild moves the node to the end, so iterating in
    // sorted order produces the correct final order.
    a.forEach(function (item) {
      var card = cardById[String(item.id)];
      if (card) list.appendChild(card);
    });

    // Inject the origin flag before the product name (once per row). Only the
    // flag is shown — the country name is already part of the product title.
    // aria-hidden: purely decorative, the title carries the origin for AT.
    list.querySelectorAll('.row').forEach(function (row) {
      var h = row.querySelector('.h');
      if (!h || h.querySelector('.org')) return;       // already done
      var f = flagOf(row.dataset.co);
      if (f) h.insertAdjacentHTML('afterbegin', '<span class="org" aria-hidden="true"><span class="flag">' + f + '</span></span>');
    });
  }

  function toast(m, ms) {
    const t = $('#tq-toast');
    t.textContent = m;
    t.classList.add('show');
    clearTimeout(toast._);
    toast._ = setTimeout(() => t.classList.remove('show'), ms || 1700);
  }

  // ---- build Origin + Process menus from the data -------------------------
  const byCont = {};
  DATA.forEach((c) => {
    if (!c.co) return;
    const k = continentOf(c.co);
    (byCont[k] = byCont[k] || new Set()).add(c.co);
  });
  const contOrder = CONT.filter((k) => byCont[k]).concat(byCont[OTHER] ? [OTHER] : []);
  const RESET_BTN = `<button class="mreset" type="button">${S.reset || 'Reset'}</button>`;
  $('#tq-mOrigin').innerHTML = contOrder.map((k) => {
    const cos = [...byCont[k]].sort();
    return `<div><button class="ocont" data-cont="${k}"><span class="cbx"></span>${contLabel(k)}</button>
      <div class="ocountries">${cos.map((co) => `<label class="opt"><input type="checkbox" class="cbx-input" data-co="${co}"><span class="cbx"></span>${flagOf(co) ? `<span class="flag">${flagOf(co)}</span> ` : ''}${co}</label>`).join('')}</div></div>`;
  }).join('') + RESET_BTN;
  // Alphabetical, accent-aware (« Égrappé » sorts with the E's, not after Z)
  const PROCS = [...new Set(DATA.map((c) => c.proc).filter(Boolean))]
    .sort((a, b) => a.localeCompare(b, document.documentElement.lang || 'fr', { sensitivity: 'base' }));
  $('#tq-mProc').innerHTML = PROCS.map((p) => `<label class="opt"><input type="checkbox" class="cbx-input" data-proc="${p}"><span class="cbx"></span>${p}</label>`).join('') + RESET_BTN;

  // ---- build bag-format menu from the data --------------------------------
  // Single-choice: "all formats" or one weight. Options come from the weights
  // present in the payload, so a new format (e.g. 44 lb) appears by itself.
  const FMTS = [...new Set(DATA.reduce((acc, c) => acc.concat(c.sizes.map((s) => s.w)), []).filter((w) => w > 0))].sort((a, b) => a - b);
  const fmtOpt = (v, label) => `<label class="opt"><input type="checkbox" class="cbx-input" data-fmt="${v}"><span class="cbx"></span>${label}</label>`;
  const fmtOpts = fmtOpt('', S.formatAll || 'All') + FMTS.map((w) => fmtOpt(w, `${w} ${S.lb || 'lb'}`)).join('');
  $('#tq-mFormat').innerHTML = fmtOpts + RESET_BTN;
  $('#tq-mobFormats').innerHTML = fmtOpts;
  if (FMTS.length < 2) {
    // Only one format in the whole catalog (or equipment only) — nothing to pick.
    $('#tq-mobFormatSec').hidden = true;
    $('#tq-bFormat').closest('.pop').style.display = 'none';
  }

  // ---- build mobile combined menu (same data, separate DOM) ---------------
  $('#tq-mobOrigins').innerHTML = contOrder.map((k) => {
    const cos = [...byCont[k]].sort();
    return `<div><button class="ocont" data-cont="${k}"><span class="cbx"></span>${contLabel(k)}</button>
      <div class="ocountries">${cos.map((co) => `<label class="opt"><input type="checkbox" class="cbx-input" data-co="${co}"><span class="cbx"></span>${flagOf(co) ? `<span class="flag">${flagOf(co)}</span> ` : ''}${co}</label>`).join('')}</div></div>`;
  }).join('');
  $('#tq-mobProcs').innerHTML = PROCS.map((p) => `<label class="opt"><input type="checkbox" class="cbx-input" data-proc="${p}"><span class="cbx"></span>${p}</label>`).join('');

  // hide empty sections in the mobile menu
  if (!contOrder.length) $('#tq-mobOriginsSec').hidden = true;
  if (!PROCS.length) $('#tq-mobProcsSec').hidden = true;

  // Flavour-palette options are server-rendered (icons + localized labels in
  // Liquid) — only hide the families no current product belongs to.
  const PALS = new Set(DATA.map((c) => c.pal).filter(Boolean));
  ['tq-mPal', 'tq-mobPals'].forEach((id) => {
    $('#' + id).querySelectorAll('.cbx-input[data-pal]').forEach((b) => {
      if (!PALS.has(b.dataset.pal)) b.closest('.opt').style.display = 'none';
    });
  });
  if (!PALS.size) {
    $('#tq-mobPalSec').hidden = true;
    $('#tq-bPal').closest('.pop').style.display = 'none';
  }

  function syncMenus() {
    $('#tq-mOrigin').querySelectorAll('.cbx-input[data-co]').forEach((b) => { b.checked = f.countries.includes(b.dataset.co); });
    $('#tq-mOrigin').querySelectorAll('.ocont').forEach((b) => {
      const cos = [...byCont[b.dataset.cont]];
      b.querySelector('.cbx').classList.toggle('on', cos.every((co) => f.countries.includes(co)));
    });
    $('#tq-mProc').querySelectorAll('.cbx-input[data-proc]').forEach((b) => { b.checked = f.procs.includes(b.dataset.proc); });
    $('#tq-mPal').querySelectorAll('.cbx-input[data-pal]').forEach((b) => { b.checked = f.pals.includes(b.dataset.pal); });
    ['tq-mFormat', 'tq-mobFormats'].forEach((id) => {
      $('#' + id).querySelectorAll('.cbx-input[data-fmt]').forEach((b) => {
        b.checked = b.dataset.fmt === '' ? f.fmt == null : f.fmt === +b.dataset.fmt;
      });
    });

    // mobile combined menu mirrors
    $('#tq-mobOrigins').querySelectorAll('.cbx-input[data-co]').forEach((b) => { b.checked = f.countries.includes(b.dataset.co); });
    $('#tq-mobOrigins').querySelectorAll('.ocont').forEach((b) => {
      const cos = [...byCont[b.dataset.cont]];
      b.querySelector('.cbx').classList.toggle('on', cos.every((co) => f.countries.includes(co)));
    });
    $('#tq-mobProcs').querySelectorAll('.cbx-input[data-proc]').forEach((b) => { b.checked = f.procs.includes(b.dataset.proc); });
    $('#tq-mobPals').querySelectorAll('.cbx-input[data-pal]').forEach((b) => { b.checked = f.pals.includes(b.dataset.pal); });
    $('#tq-mobSale').checked = f.sale;
    $('#tq-mobNew').checked = f.isNew;

    // sync price inputs both ways
    if (document.activeElement !== $('#tq-pMinMob')) $('#tq-pMinMob').value = f.pMin == null ? '' : f.pMin;
    if (document.activeElement !== $('#tq-pMaxMob')) $('#tq-pMaxMob').value = f.pMax == null ? '' : f.pMax;
    if (document.activeElement !== $('#tq-pMin')) $('#tq-pMin').value = f.pMin == null ? '' : f.pMin;
    if (document.activeElement !== $('#tq-pMax')) $('#tq-pMax').value = f.pMax == null ? '' : f.pMax;
  }

  let ACTS = [];
  function chip(label, fn) {
    const i = ACTS.push(fn) - 1;
    return `<button class="ac" data-i="${i}">${label}<span class="x">×</span></button>`;
  }
  function renderChips() {
    ACTS = [];
    const out = [];
    f.countries.forEach((co) => out.push(chip(co, () => { f.countries = f.countries.filter((x) => x !== co); })));
    f.procs.forEach((p) => out.push(chip(p, () => { f.procs = f.procs.filter((x) => x !== p); })));
    f.pals.forEach((k) => out.push(chip((S.palette || {})[k] || k, () => { f.pals = f.pals.filter((x) => x !== k); })));
    if (f.fmt != null) out.push(chip(`${f.fmt} ${S.lb || 'lb'}`, () => { f.fmt = null; }));
    if (f.sale) out.push(chip(S.sale || 'On sale', () => { f.sale = false; }));
    if (f.isNew) out.push(chip(S.new || 'New', () => { f.isNew = false; }));
    if (f.pMin != null || f.pMax != null) {
      out.push(chip(`${f.pMin != null ? SYM + f.pMin : SYM + '0'}–${f.pMax != null ? SYM + f.pMax : '∞'}${S.perLb || '/lb'}`, () => { f.pMin = f.pMax = null; }));
    }
    $('#tq-chips').innerHTML = out.length ? out.join('') + `<button class="clr" id="tq-clrAll">${S.clearAll || 'Clear all'}</button>` : '';
  }

  // ---- URL hash state -------------------------------------------------------
  // Filter + sort state lives in the URL hash (#co=…&proc=…&fmt=…&pmin=…&
  // pmax=…&sale=1&new=1&q=…&sort=…) so a filtered view survives reloads and can be
  // shared.
  function readHash() {
    const h = location.hash.replace(/^#/, '');
    if (!h) return;
    const p = new URLSearchParams(h);
    if (p.get('co')) f.countries = p.get('co').split('~').filter(Boolean);
    if (p.get('proc')) f.procs = p.get('proc').split('~').filter(Boolean);
    if (p.get('pal')) f.pals = p.get('pal').split('~').filter(Boolean);
    if (p.get('fmt')) f.fmt = +p.get('fmt') || null;
    if (p.get('pmin')) f.pMin = +p.get('pmin');
    if (p.get('pmax')) f.pMax = +p.get('pmax');
    if (p.has('sale')) f.sale = true;
    if (p.has('new')) f.isNew = true;
    if (p.has('stock')) f.avail = true;
    if (p.get('q')) { f.q = p.get('q'); if (qInput) qInput.value = f.q; }
    const s = p.get('sort');
    if (s && $('#tq-sort').querySelector('option[value="' + s + '"]')) {
      sort = s;
      $('#tq-sort').value = s;
    }
  }
  function writeHash() {
    const p = new URLSearchParams();
    if (f.countries.length) p.set('co', f.countries.join('~'));
    if (f.procs.length) p.set('proc', f.procs.join('~'));
    if (f.pals.length) p.set('pal', f.pals.join('~'));
    if (f.fmt != null) p.set('fmt', f.fmt);
    if (f.pMin != null) p.set('pmin', f.pMin);
    if (f.pMax != null) p.set('pmax', f.pMax);
    if (f.sale) p.set('sale', '1');
    if (f.isNew) p.set('new', '1');
    if (f.avail) p.set('stock', '1');
    if (f.q) p.set('q', f.q);
    if (sort !== 'latest') p.set('sort', sort);
    const q = p.toString();
    history.replaceState(null, '', q ? '#' + q : location.pathname + location.search);
  }

  function badge(el, n) { el.textContent = n; el.hidden = !n; }
  function update() {
    writeHash();
    render();
    renderChips();
    syncMenus();
    badge($('#tq-ctOrigin'), f.countries.length);
    badge($('#tq-ctProc'), f.procs.length);
    badge($('#tq-ctPal'), f.pals.length);
    badge($('#tq-ctFormat'), f.fmt != null ? 1 : '');
    badge($('#tq-ctPrice'), (f.pMin != null || f.pMax != null) ? 1 : '');
    // per-section badges on the mobile sheet's accordion summaries
    badge($('#tq-mobCtOrigin'), f.countries.length);
    badge($('#tq-mobCtProc'), f.procs.length);
    badge($('#tq-mobCtPal'), f.pals.length);
    badge($('#tq-mobCtFormat'), f.fmt != null ? 1 : '');
    badge($('#tq-mobCtPrice'), (f.pMin != null || f.pMax != null) ? 1 : '');
    $('#tq-fSale').classList.toggle('on', f.sale);
    $('#tq-fNew').classList.toggle('on', f.isNew);
    stockWrap.querySelectorAll('[data-tq-stock]').forEach((b) => {
      b.setAttribute('aria-pressed', String((b.dataset.tqStock === 'in') === f.avail));
    });
    // a query from the hash (or a shared link) must be visible, not hidden
    // behind the collapsed magnifier
    if (f.q) setSearchOpen(true, false);
    // combined mobile badge: total active filters
    const total = f.countries.length + f.procs.length + f.pals.length + (f.fmt != null ? 1 : 0) + (f.pMin != null || f.pMax != null ? 1 : 0) + (f.sale ? 1 : 0) + (f.isNew ? 1 : 0);
    badge($('#tq-ctAll'), total);
    // highlight mobile filter button when any filter is active
    $('#tq-bAll').classList.toggle('on', total > 0);
  }

  // ---- cart ---------------------------------------------------------------
  // Query the badge at call time: the stock cart JS re-renders the header
  // icon's innerHTML (sections/cart-icon-bubble.liquid) after drawer updates,
  // so a cached node could go stale.
  function setCount(n) {
    const cartCountEl = _dollar_global('#tq-cc');
    if (!cartCountEl) return;
    cartCountEl.textContent = n;
    cartCountEl.hidden = !n;
  }
  async function refreshCount() {
    try {
      const r = await fetch(`${window.routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
      const cart = await r.json();
      setCount(cart.item_count);
    } catch (e) { /* leave count as-is */ }
  }
  // Pull a readable message out of a failed cart/add response, across the
  // different shapes Shopify uses (errors string, errors object, description).
  function cartErrorMessage(data) {
    if (!data) return '';
    const e = data.errors;
    if (typeof e === 'string') return e;
    if (e && typeof e === 'object') {
      return Object.keys(e).map((k) => [].concat(e[k]).join(' ')).join(' ').trim();
    }
    return data.description || data.message || '';
  }
  // items: [{id, quantity, properties?}, …] — one line for a plain green add,
  // plus fee lines (roasting / packaging) in Café cuit roasting mode. One
  // atomic POST: Shopify rejects the whole add if any line fails, so a roasted
  // coffee can never land in the cart without its fee.
  async function addToCart(items, label, btn) {
    const qty = Math.max(1, parseInt(items[0] && items[0].quantity, 10) || 1);
    btn.disabled = true;
    btn.classList.add('is-loading');
    // When the theme's cart drawer is present (cart_type == 'drawer'), ask the
    // Section Rendering API for the drawer + header badge HTML in the same
    // request, then slide the drawer open as the add-to-cart feedback.
    const drawer = document.querySelector('cart-drawer');
    const canDrawer = drawer && typeof drawer.renderContents === 'function';
    try {
      const body = { items };
      if (canDrawer) {
        body.sections = drawer.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
        drawer.setActiveElement(document.activeElement);
      }
      const res = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await res.json().catch(() => null);
      if (!res.ok) {
        // Surface Shopify's human-readable reason (e.g. stock too low) instead
        // of a generic error. The shape varies: stock/quantity errors come back
        // as `errors` (a string, or an object of field -> [messages]); other
        // cart errors use `description`/`message`. Keep the generic message as a
        // prefix so the customer still gets context, e.g. "Something went wrong: …".
        const generic = S.cartError || 'Something went wrong';
        const reason = cartErrorMessage(data);
        toast(reason ? `${generic}: ${reason}` : generic, 4000);
        return;
      }
      if (canDrawer && data && data.sections) {
        // The opening drawer is the feedback — no toast, and no cartUpdate
        // publish (it would only trigger a redundant section refetch).
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
        // pop the freshly-rendered total so the new amount reads as a reaction
        // to the add rather than a silent swap (styles in tq-cart-drawer.css)
        drawer.querySelectorAll('.mini-total, .tval').forEach((el) => el.classList.add('tq-bump'));
      } else {
        await refreshCount();
        toast(fmt(S.added || 'Added {name}', { name: (qty > 1 ? qty + ' × ' : '') + label }));
        // Let the theme's cart drawer/bubble refresh if it is listening.
        if (window.PUB_SUB_EVENTS && typeof publish === 'function') {
          publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'home-catalog' });
        }
      }
    } catch (e) {
      toast(S.cartError || 'Something went wrong');
    } finally {
      btn.disabled = false;
      btn.classList.remove('is-loading');
    }
  }

  // ---- events -------------------------------------------------------------
  $('#tq-list').addEventListener('click', (e) => {
    // Quantity stepper +/−
    const step = e.target.closest('.qbtn');
    if (step) {
      const input = step.parentElement.querySelector('.qnum');
      if (input && !input.disabled) {
        const v = Math.max(1, parseInt(input.value, 10) || 1);
        input.value = step.classList.contains('qup') ? v + 1 : Math.max(1, v - 1);
      }
      return;
    }
    // More-info toggle
    const more = e.target.closest('.more-btn');
    if (more) {
      const expanded = more.getAttribute('aria-expanded') === 'true';
      more.setAttribute('aria-expanded', !expanded);
      const panel = document.getElementById(more.getAttribute('aria-controls'));
      if (panel) panel.hidden = expanded; // inverted: if was open, close
    }
  });

  // Add to cart — each .sb is a real <form action="/cart/add">, so the button
  // works natively before this script loads (or with JS off). Once we're here,
  // intercept the submit (covers mouse + keyboard) and do the AJAX add instead.
  $('#tq-list').addEventListener('submit', (e) => {
    const form = e.target.closest('form.sb');
    if (!form) return;
    e.preventDefault();
    const b = form.querySelector('.add[data-variant]');
    if (!b || b.disabled) return;
    // Café cuit: collect roast / packaging / colour in a popup before adding.
    if (ccModal && b.dataset.ccOptions) {
      openCc(b);
      return;
    }
    const qn = form.querySelector('.qnum');
    const qty = Math.max(1, parseInt(qn && qn.value, 10) || 1);
    const items = [{ id: Number(b.dataset.variant), quantity: qty }];
    // Roasting mode without a popup (no packaging product): green bag + fee.
    if (b.dataset.roastVariant) {
      items[0].properties = { _tq_roasted: 'direct' };
      items.push({
        id: Number(b.dataset.roastVariant),
        quantity: qty,
        properties: { _tq_for: `${b.dataset.variant}|direct` },
      });
    }
    addToCart(items, b.dataset.label, b);
  });

  // ---- Café cuit options popup ------------------------------------------
  // Fieldset markup comes from snippets/tq-roasting-fields.liquid (shared with
  // the PDP block, assets/tq-roasting.js): data-prop = the line-item property
  // key, data-fee marks the paid packaging group (chosen option's data-variant
  // is added as its own cart line), data-color-fs is the bag-colour group and
  // option[data-colors] lists the colours the chosen bag exists in.
  const ccModal = document.getElementById('tq-ccModal');
  const ccForm = document.getElementById('tq-ccForm');
  const ccError = document.getElementById('tq-ccError');
  const ccTitle = ccModal && ccModal.querySelector('.cc-coffee');
  const ccColor = ccForm && ccForm.querySelector('fieldset[data-color-fs]');
  const ccPkg = ccForm && ccForm.querySelector('fieldset[data-fee] select');
  let ccTarget = null; // the row .add button that opened the modal

  // Bag colour only applies when a real packaging bag is chosen (not bulk),
  // and only in the colours that bag exists in; a single allowed colour is
  // checked automatically. Disabled while hidden so it never validates.
  function syncCcColor() {
    if (!ccColor) return;
    const opt = ccPkg && ccPkg.options[ccPkg.selectedIndex];
    const isBag = !ccPkg || (opt && opt.dataset.variant);
    if (!isBag) {
      ccColor.hidden = true;
      ccColor.disabled = true;
      return;
    }
    const colors = (opt && opt.dataset.colors ? opt.dataset.colors : 'noir,kraft').split(',');
    ccColor.hidden = false;
    ccColor.disabled = false;
    ccColor.querySelectorAll('label[data-color]').forEach((label) => {
      const allowed = colors.includes(label.dataset.color);
      const input = label.querySelector('input');
      label.hidden = !allowed;
      input.disabled = !allowed;
      if (!allowed) input.checked = false;
    });
    const enabled = ccColor.querySelectorAll('input:not(:disabled)');
    if (enabled.length === 1) enabled[0].checked = true;
  }

  function openCc(btn) {
    ccTarget = btn;
    if (ccError) ccError.hidden = true;
    ccForm.reset();
    syncCcColor();
    if (ccTitle) ccTitle.textContent = btn.dataset.label || ccTitle.dataset.default || ccTitle.textContent;
    ccModal.hidden = false;
    document.body.style.overflow = 'hidden';
    const first = ccForm && ccForm.querySelector('input, select');
    if (first) first.focus();
  }
  function closeCc() {
    if (!ccModal) return;
    ccModal.hidden = true;
    document.body.style.overflow = '';
    ccTarget = null;
  }

  if (ccModal) {
    ccModal.addEventListener('click', (e) => {
      if (e.target.closest('[data-cc-close]')) closeCc();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !ccModal.hidden) closeCc();
    });
    if (ccPkg) ccPkg.addEventListener('change', syncCcColor);
    // Answering a flagged question clears its error state immediately
    ccForm.addEventListener('change', (e) => {
      const fs = e.target.closest('fieldset[data-prop]');
      if (fs) fs.classList.remove('cc-miss');
    });
    ccForm.addEventListener('submit', (e) => {
      e.preventDefault();
      if (!ccTarget) return;
      // Build the line-item properties from the answered fieldsets. The
      // data-fee group may carry a paid packaging variant added as its own line.
      const props = {};
      let packagingId = null;
      // Per-field validation: every unanswered fieldset gets flagged (not just
      // a single generic message), and focus moves to the first one so both
      // sighted and AT users land on what's missing.
      const missing = [];
      ccForm.querySelectorAll('fieldset[data-prop]').forEach((fs) => {
        // Skip questions that don't apply (e.g. colour when packaging is bulk).
        if (fs.hidden || fs.disabled) return;
        // A fieldset is answered via a <select> (packaging) or radios (roast/colour).
        const sel = fs.querySelector('select');
        const chosen = sel ? sel.options[sel.selectedIndex] : fs.querySelector('input:checked');
        fs.classList.remove('cc-miss');
        if (!chosen) {
          missing.push(fs);
          return;
        }
        if (fs.dataset.fee) {
          // Paid options carry data-variant; the default "bulk" option has
          // none, so nothing is added to the cart for it.
          if (chosen.dataset.variant) packagingId = Number(chosen.dataset.variant);
          props[fs.dataset.prop] = chosen.dataset.label || chosen.value;
        } else {
          props[fs.dataset.prop] = chosen.value;
        }
      });
      if (missing.length) {
        missing.forEach((fs) => fs.classList.add('cc-miss'));
        if (ccError) {
          // Re-announce on every failed attempt: role=alert only fires on
          // insertion/appearance, so toggle hidden even when already shown.
          ccError.hidden = true;
          ccError.hidden = false;
        }
        const firstInput = missing[0].querySelector('select, input:not(:disabled)');
        if (firstInput) firstInput.focus();
        return;
      }
      // Deterministic fingerprint: identical configurations merge into the
      // same cart lines; tq-roasting-cart.js keys its reconciliation on it —
      // fee lines follow their coffee line's quantity and never outlive it.
      const coffeeId = Number(ccTarget.dataset.variant);
      const fp = Object.values(props).join('|');
      props._tq_roasted = fp;
      const link = `${coffeeId}|${fp}`;
      const items = [{ id: coffeeId, quantity: 1, properties: props }];
      if (ccTarget.dataset.roastVariant) {
        items.push({ id: Number(ccTarget.dataset.roastVariant), quantity: 1, properties: { _tq_for: link } });
      }
      if (packagingId) items.push({ id: packagingId, quantity: 1, properties: { _tq_for: link } });
      const btn = ccTarget;
      const label = ccTarget.dataset.label;
      closeCc();
      addToCart(items, label, btn);
    });
  }

  // Clamp the quantity input to a positive integer when edited directly.
  $('#tq-list').addEventListener('change', (e) => {
    const q = e.target.closest('.qnum');
    if (q) q.value = Math.max(1, parseInt(q.value, 10) || 1);
  });

  $('#tq-mOrigin').addEventListener('click', (e) => {
    if (e.target.closest('.mreset')) {
      f.countries = [];
      update();
      return;
    }
    const cont = e.target.closest('.ocont');
    if (cont) {
      const cos = [...byCont[cont.dataset.cont]];
      const all = cos.every((c) => f.countries.includes(c));
      f.countries = all ? f.countries.filter((c) => !cos.includes(c)) : [...new Set([...f.countries, ...cos])];
      update();
    }
  });
  $('#tq-mOrigin').addEventListener('change', (e) => {
    const co = e.target.closest('.cbx-input[data-co]');
    if (!co) return;
    const v = co.dataset.co;
    f.countries = f.countries.includes(v) ? f.countries.filter((x) => x !== v) : [...f.countries, v];
    update();
  });
  $('#tq-mProc').addEventListener('click', (e) => {
    if (e.target.closest('.mreset')) {
      f.procs = [];
      update();
    }
  });
  $('#tq-mProc').addEventListener('change', (e) => {
    const p = e.target.closest('.cbx-input[data-proc]');
    if (!p) return;
    const v = p.dataset.proc;
    f.procs = f.procs.includes(v) ? f.procs.filter((x) => x !== v) : [...f.procs, v];
    update();
  });
  $('#tq-mPal').addEventListener('click', (e) => {
    if (e.target.closest('.mreset')) {
      f.pals = [];
      update();
    }
  });
  // Bag format: single-choice — checking a weight replaces the previous one,
  // unchecking it (or picking "all formats") clears the filter. syncMenus()
  // re-checks the right box, so the checkboxes behave like radios.
  function fmtFromInput(b) {
    f.fmt = b.dataset.fmt === '' || !b.checked ? null : +b.dataset.fmt;
    update();
  }
  $('#tq-mFormat').addEventListener('click', (e) => {
    if (e.target.closest('.mreset')) {
      f.fmt = null;
      update();
    }
  });
  $('#tq-mFormat').addEventListener('change', (e) => {
    const b = e.target.closest('.cbx-input[data-fmt]');
    if (b) fmtFromInput(b);
  });
  $('#tq-mPal').addEventListener('change', (e) => {
    const b = e.target.closest('.cbx-input[data-pal]');
    if (!b) return;
    const v = b.dataset.pal;
    f.pals = f.pals.includes(v) ? f.pals.filter((x) => x !== v) : [...f.pals, v];
    update();
  });

  function priceFromInputs() {
    const a = $('#tq-pMin').value;
    const b = $('#tq-pMax').value;
    f.pMin = a === '' ? null : +a;
    f.pMax = b === '' ? null : +b;
    update();
  }
  $('#tq-pMin').addEventListener('input', priceFromInputs);
  $('#tq-pMax').addEventListener('input', priceFromInputs);
  $('#tq-mPrice').querySelectorAll('.ppre button').forEach((b) => b.addEventListener('click', () => {
    f.pMin = b.dataset.min === '' ? null : +b.dataset.min;
    f.pMax = b.dataset.max === '' ? null : +b.dataset.max;
    $('#tq-pMin').value = f.pMin == null ? '' : f.pMin;
    $('#tq-pMax').value = f.pMax == null ? '' : f.pMax;
    update();
  }));
  $('#tq-pReset').addEventListener('click', () => {
    f.pMin = f.pMax = null;
    $('#tq-pMin').value = '';
    $('#tq-pMax').value = '';
    update();
  });

  function clearAllFilters() {
    f.countries = []; f.procs = []; f.pals = []; f.fmt = null; f.pMin = f.pMax = null; f.sale = false; f.isNew = false; f.avail = false;
    f.q = ''; if (qInput) qInput.value = '';
    setSearchOpen(false, false);
    $('#tq-pMin').value = ''; $('#tq-pMax').value = '';
    $('#tq-pMinMob').value = ''; $('#tq-pMaxMob').value = '';
    update();
  }
  const noMatchClr = $('#tq-noMatchClr');
  if (noMatchClr) noMatchClr.addEventListener('click', clearAllFilters);

  $('#tq-chips').addEventListener('click', (e) => {
    if (e.target.id === 'tq-clrAll') {
      clearAllFilters();
      return;
    }
    const b = e.target.closest('[data-i]');
    if (!b) return;
    ACTS[+b.dataset.i]();
    $('#tq-pMin').value = f.pMin == null ? '' : f.pMin;
    $('#tq-pMax').value = f.pMax == null ? '' : f.pMax;
    update();
  });

  $('#tq-fSale').addEventListener('click', () => { f.sale = !f.sale; update(); });
  $('#tq-fNew').addEventListener('click', () => { f.isNew = !f.isNew; update(); });
  // No new arrivals in the data → hide the toggle rather than offer a dead end
  if (!DATA.some((c) => c.isNew)) { $('#tq-fNew').hidden = true; $('#tq-mobNewRow').hidden = true; }
  $('#tq-sort').addEventListener('change', (e) => { sort = e.target.value; update(); });
  if (qInput) qInput.addEventListener('input', () => { f.q = qInput.value; update(); });

  // ---- collapsible search (magnifier → pill) --------------------------------
  // Same gesture as the header search: only the magnifier shows until it is
  // clicked; the pill then grows out of it (CSS transition on .is-open). It
  // folds back on Escape, on the × (both also clear the query), or when focus
  // leaves it while empty — a pill holding a query stays open so the active
  // filter is never hidden.
  const searchWrap = $('#tq-search');
  const qBtn = $('#tq-qBtn');
  const qClose = $('#tq-qClose');
  function setSearchOpen(open, focus) {
    if (!searchWrap) return;
    searchWrap.classList.toggle('is-open', open);
    qBtn.setAttribute('aria-expanded', String(open));
    qInput.tabIndex = open ? 0 : -1;
    qClose.tabIndex = open ? 0 : -1;
    if (open && focus) qInput.focus({ preventScroll: true });
  }
  function closeSearch() {
    if (f.q) { f.q = ''; qInput.value = ''; update(); }
    setSearchOpen(false, false);
    qBtn.focus({ preventScroll: true });
  }
  if (searchWrap) {
    qBtn.addEventListener('click', () => {
      if (!searchWrap.classList.contains('is-open')) setSearchOpen(true, true);
      else if (!f.q) setSearchOpen(false, false);
      else qInput.focus({ preventScroll: true });
    });
    qClose.addEventListener('click', closeSearch);
    qInput.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      e.preventDefault();
      e.stopPropagation();
      closeSearch();
    });
    searchWrap.addEventListener('focusout', (e) => {
      if (searchWrap.contains(e.relatedTarget)) return;
      if (!f.q) setSearchOpen(false, false);
    });
  }

  // ---- availability toggle (in stock / all) ----------------------------------
  const stockWrap = $('#tq-stock');
  stockWrap.addEventListener('click', (e) => {
    const b = e.target.closest('[data-tq-stock]');
    if (!b) return;
    f.avail = b.dataset.tqStock === 'in';
    update();
  });

  // ---- view toggle (list / cards) -------------------------------------------
  // data-view lives on the .tq-catalog root: server-rendered from the theme
  // setting (settings.catalog_default_view), possibly already swapped before
  // paint by the inline script in tq-catalog.liquid. The card layout itself is
  // pure CSS (tq-catalog.css, scope [data-view="cards"]) — here we only sync
  // the attribute, the buttons and localStorage.
  const viewWrap = $('#tq-view');
  function setView(v, persist) {
    if (v !== 'cards') v = 'list';
    root.setAttribute('data-view', v);
    // Re-declare the rendered size so the browser upgrades srcset renditions
    // for the large card layout (it never downgrades already-loaded ones).
    const imgSizes = v === 'cards' ? '(max-width: 820px) 92vw, 340px' : '100px';
    root.querySelectorAll('.thumb-img').forEach((im) => { im.sizes = imgSizes; });
    if (viewWrap) {
      viewWrap.querySelectorAll('[data-tq-view]').forEach((b) => {
        b.setAttribute('aria-pressed', String(b.dataset.tqView === v));
      });
    }
    if (persist) {
      try { localStorage.setItem('tq_view', v); } catch (e) { /* private mode */ }
    }
  }
  if (viewWrap) {
    viewWrap.addEventListener('click', (e) => {
      const b = e.target.closest('[data-tq-view]');
      if (b) setView(b.dataset.tqView, true);
    });
  }
  // sync aria-pressed with the (possibly pre-paint-swapped) attribute
  setView(root.getAttribute('data-view'), false);

  // ---- mobile combined menu events ----------------------------------------
  // Origin clicks — same logic as desktop
  $('#tq-mobOrigins').addEventListener('click', (e) => {
    const cont = e.target.closest('.ocont');
    if (!cont) return;
    const cos = [...byCont[cont.dataset.cont]];
    const all = cos.every((c) => f.countries.includes(c));
    f.countries = all ? f.countries.filter((c) => !cos.includes(c)) : [...new Set([...f.countries, ...cos])];
    update();
  });
  $('#tq-mobOrigins').addEventListener('change', (e) => {
    const co = e.target.closest('.cbx-input[data-co]');
    if (!co) return;
    const v = co.dataset.co;
    f.countries = f.countries.includes(v) ? f.countries.filter((x) => x !== v) : [...f.countries, v];
    update();
  });
  // Process clicks
  $('#tq-mobProcs').addEventListener('change', (e) => {
    const p = e.target.closest('.cbx-input[data-proc]');
    if (!p) return;
    const v = p.dataset.proc;
    f.procs = f.procs.includes(v) ? f.procs.filter((x) => x !== v) : [...f.procs, v];
    update();
  });
  // Flavour-palette clicks
  $('#tq-mobPals').addEventListener('change', (e) => {
    const b = e.target.closest('.cbx-input[data-pal]');
    if (!b) return;
    const v = b.dataset.pal;
    f.pals = f.pals.includes(v) ? f.pals.filter((x) => x !== v) : [...f.pals, v];
    update();
  });
  // Mobile price inputs — sync to state
  function priceFromMobInputs() {
    const a = $('#tq-pMinMob').value;
    const b = $('#tq-pMaxMob').value;
    f.pMin = a === '' ? null : +a;
    f.pMax = b === '' ? null : +b;
    update();
  }
  $('#tq-pMinMob').addEventListener('input', priceFromMobInputs);
  $('#tq-pMaxMob').addEventListener('input', priceFromMobInputs);
  // Mobile price presets
  $('#tq-mobPriceSec').querySelectorAll('.ppre button').forEach((b) => b.addEventListener('click', () => {
    f.pMin = b.dataset.min === '' ? null : +b.dataset.min;
    f.pMax = b.dataset.max === '' ? null : +b.dataset.max;
    $('#tq-pMinMob').value = f.pMin == null ? '' : f.pMin;
    $('#tq-pMaxMob').value = f.pMax == null ? '' : f.pMax;
    update();
  }));
  // Mobile bag-format clicks — same single-choice logic as desktop
  $('#tq-mobFormats').addEventListener('change', (e) => {
    const b = e.target.closest('.cbx-input[data-fmt]');
    if (b) fmtFromInput(b);
  });
  // Mobile sale / stock toggles
  $('#tq-mobSale').addEventListener('change', (e) => { f.sale = e.target.checked; update(); });
  $('#tq-mobNew').addEventListener('change', (e) => { f.isNew = e.target.checked; update(); });
  // Mobile clear all
  $('#tq-mobClrAll').addEventListener('click', clearAllFilters);

  // ---- popover open/close (desktop) ---------------------------------------
  [['tq-bOrigin', 'tq-mOrigin'], ['tq-bProc', 'tq-mProc'], ['tq-bPal', 'tq-mPal'], ['tq-bFormat', 'tq-mFormat'], ['tq-bPrice', 'tq-mPrice']].forEach(([b, m]) => {
    $('#' + b).addEventListener('click', (e) => {
      e.stopPropagation();
      const menu = $('#' + m);
      const open = !menu.hidden;
      root.querySelectorAll('.menu').forEach((x) => { x.hidden = true; });
      menu.hidden = open;
    });
  });
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.pop')) root.querySelectorAll('.menu').forEach((x) => { x.hidden = true; });
  });

  // ---- mobile filter panel open/close ------------------------------------
  const mobOverlay = $('#tq-mobOverlay');
  function openMob() {
    mobOverlay.classList.add('mob-open');
    document.body.style.overflow = 'hidden';
  }
  function closeMob() {
    mobOverlay.classList.remove('mob-open');
    document.body.style.overflow = '';
  }
  $('#tq-bAll').addEventListener('click', (e) => {
    e.stopPropagation();
    if (mobOverlay.classList.contains('mob-open')) {
      closeMob();
    } else {
      // close any open desktop menus first
      root.querySelectorAll('.menu').forEach((x) => { x.hidden = true; });
      openMob();
    }
  });
  // backdrop click → close
  mobOverlay.querySelector('.tq-mob-backdrop').addEventListener('click', closeMob);
  // close button → close
  $('#tq-mobClose').addEventListener('click', closeMob);
  // "View N coffees" footer button → close (filters already applied live)
  $('#tq-mobApply').addEventListener('click', closeMob);
  // Escape → close
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && mobOverlay.classList.contains('mob-open')) closeMob();
  });
  // close mobile panel if user resizes past the mobile breakpoint
  window.addEventListener('resize', () => {
    if (window.innerWidth > 820 && mobOverlay.classList.contains('mob-open')) closeMob();
  });

  // sticky bar shadow
  const sent = document.createElement('div');
  sent.style.cssText = 'position:absolute;top:0;height:1px;width:1px;';
  root.prepend(sent);
  new IntersectionObserver(([x]) => $('#tq-bar').classList.toggle('stuck', !x.isIntersecting), { threshold: 1 }).observe(sent);

  // seed cart count rendered by Liquid, then apply hash state and render
  const cc = _dollar_global('#tq-cc');
  const seeded = parseInt(cc && cc.dataset.count, 10);
  if (!isNaN(seeded)) setCount(seeded);

  readHash();
  update();

  window.addEventListener('hashchange', () => {
    f.countries = []; f.procs = []; f.pals = []; f.fmt = null; f.pMin = f.pMax = null; f.sale = false; f.isNew = false; f.avail = false;
    f.q = ''; if (qInput) qInput.value = '';
    sort = 'latest';
    $('#tq-sort').value = sort;
    readHash();
    update();
  });
})();
